module.exports = __webpack_public_path__ + "static/media/toiletCorrect.6d4ba977.png";